import { GET_API } from "./../../Functionalities/APIs";

export const ManageDashBoardMostRatedProducts = async (
  e,
  keyword,
  data,
  params
) => {
  let path = "/branch/mostrated/";

  if (keyword === "get") {
    let result = GET_API("", params, path);
    // void 0

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageDashBoard = async (e, keyword, data, params) => {
  let path = "/admindashboard/";

  if (keyword == "get") {
    let result = GET_API("", params, path);
    // void 0

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const ManageDashBoardOrderSummary = async (e, keyword, data, params) => {
  let path = "/admindashboard/ordersummary/";

  if (keyword == "get") {
    let result = GET_API("", params, path);
    // void 0

    return await result.then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    });
  }
};

export const GET_GRAPH_DATA = (franchiseParams = "") => {
  var d = new Date();
  var ts = d.getTime();
  var sevenDays = ts - 7 * 24 * 60 * 60 * 1000;

  let path =
    "/admindashboard/graph/?from_date=" +
    new Date(sevenDays).toISOString().slice(0, 10) +
    " 00:00:00&to_date=" +
    d.toISOString().slice(0, 10) +
    " 00:00:00&order_type=delivered" +
    (franchiseParams ? "&" + franchiseParams : "");

  let result = GET_API("", "", path);
  // void 0

  return result
    .then((result) => {
      // void 0
      if (result) {
        // void 0
        return result;
      } else {
        return 0;
      }
    })
    .catch((err) => {
      // void 0
    });
};
